"use client";

import { createContext, useContext } from "react";

export const DomainContext = createContext<{
  domain: "shopsite" | "whitelabel";
  requiresCookieConsent: boolean;
  domainName?: string;
} | null>({ domain: "shopsite", requiresCookieConsent: true });

export function useIsShopsite() {
  const context = useContext(DomainContext);
  if (context === null) {
    throw new Error(
      "useIsShopsite must be used within a DomainContextProvider"
    );
  }
  return context.domain === "shopsite";
}

export function useRequiresCookieConsent() {
  const context = useContext(DomainContext);
  if (context === null) {
    throw new Error(
      "useRequiresCookieConsent must be used within a DomainContextProvider"
    );
  }
  return context.requiresCookieConsent;
}

export function useDomainName() {
  const context = useContext(DomainContext);
  if (context === null) {
    throw new Error(
      "useDomainName must be used within a DomainContextProvider"
    );
  }
  return context.domainName;
}

export function DomainContextProvider({
  children,
  domain,
  requiresCookieConsent,
  domainName,
}: {
  children: React.ReactNode;
  domain: "shopsite" | "whitelabel";
  requiresCookieConsent?: boolean;
  domainName?: string;
}) {
  return (
    <DomainContext.Provider
      value={{
        domain,
        requiresCookieConsent: !!requiresCookieConsent,
        domainName,
      }}
    >
      {children}
    </DomainContext.Provider>
  );
}
